import { ASSETS } from "./shared";

const owners = [
  {
    id: "jonathan-rushmore",
    name: "Jonathan Rushmore",
    img: ASSETS.ownerJonathan,
    alt: "Jonathan Rushmore, co-owner",
  },
  {
    id: "dee-pino",
    name: "Dee Pino",
    img: ASSETS.ownerDee,
    alt: "Dee Pino, co-owner",
  },
];

export const Owners = () => (
  <section
    data-testid="owners-section"
    className="py-20 md:py-28 px-6 md:px-12 max-w-6xl mx-auto border-t border-[#3B2760]"
  >
    <span className="mono-lbl text-xs text-[#FF2E88] uppercase font-bold">The People</span>
    <h2 className="display-type text-3xl md:text-5xl font-bold uppercase mt-2 mb-12">
      Meet the Owners
    </h2>
    <div className="grid sm:grid-cols-2 gap-6 max-w-3xl">
      {owners.map((o) => (
        <div
          key={o.id}
          data-testid={`owner-${o.id}`}
          className="bg-[#26153F] rounded-2xl border border-[#3B2760] overflow-hidden group"
        >
          <div className="aspect-square overflow-hidden">
            <img
              src={o.img}
              alt={o.alt}
              loading="lazy"
              className="card-img w-full h-full object-cover"
            />
          </div>
          <div className="p-6 flex items-baseline justify-between">
            <p className="font-bold text-lg">{o.name}</p>
            <p className="mono-lbl text-xs uppercase text-[#FF2E88] font-bold">Owner</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);
